<template>
    <div>
        <v-dialog v-model="metricsdialog"
                  max-width="600"
                  :overlay="false"
                  scrollable

        >
            <v-card>
                <v-card-title>
                    {{this.player.info.firstname}} {{this.player.info.lastname}} Metrix
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="4" >
                                <v-card outlined color="awesome" @click="datadiv='emailviews'" height="120">
                                    <v-icon color="white" class="pa-1"  large>mdi-email</v-icon>
                                    <div class="tilefeature">{{emailcnt}}</div>
                                    <div class="tiletitle">Emails Sent</div>
                                </v-card>
                            </v-col>

                            <v-col cols="12" sm="4">
                                <v-card outlined color="awesome" @click="datadiv='videoviews'" height="120">
                                    <v-icon color="white"  class="pa-1"   large>mdi-video-box</v-icon>
                                    <div class="tilefeature">{{videoviewsct}}</div>
                                    <div class="tiletitle">Video Views</div>
                                </v-card>
                            </v-col>

                            <v-col cols="12" sm="4">
                                <v-card outlined color="awesome" @click="recentPageViews()" height="120">
                                    <v-icon color="white"  class="pa-1"  large>mdi-web-box</v-icon>
                                    <div class="tilefeature">{{visitorsct}}</div>
                                    <div class="tiletitle">Page Views</div>
                                </v-card>
                            </v-col>

                        </v-row>

                        <div v-if="datadiv==='pageviews'">
                            <v-row>
                                <v-col cols="12" class="text-xs-center">
                                    <h3>Week # {{week}}-{{year}}</h3>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3"><v-btn text @click="pageviewsbyweek('-')"><v-icon >{{icons.menuleft}}</v-icon></v-btn></v-col>
                                <v-col cols="3"><v-btn text @click="pageviewsbyweek('now')"><v-icon>mdi-calendar-today</v-icon></v-btn></v-col>
                                <v-col cols="3"><v-btn text @click="pageviewsbyweek('+')"><v-icon>{{icons.menuright}}</v-icon></v-btn></v-col>
                                <v-col cols="3">
                                    <v-btn text @click="recentPageViews()">
                                    <v-icon>mdi-calendar-clock</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row row wrap >
                                <v-col cols="12">
                                    <v-list dense>
                                        <v-list-item v-for="(v,i) in viewsbyweek" @click="showknown(v)">
                                            <v-list-item-content>
                                                <v-list-item-title>{{v.url}}</v-list-item-title>
                                                <v-list-item-subtitle>{{ v.createdAt | moment("MMMM Do YYYY h:mm:ss a") }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </div>

                        <div v-if="datadiv==='emailviews'">
                            <v-list two-line>
                                <v-list-item avatar ripple v-for="(m,i) in email":key="i" @click="getemaildetails(m.sender,m.messageid)">
                                    <v-list-item-content>
                                        <v-list-item-title>{{m.destination.name}}</v-list-item-title>
                                        <v-list-item-sub-title >{{m.destination.organization}}</v-list-item-sub-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </div>

                        <div v-if="datadiv==='videoviews'">
                            <v-list-item v-for="(v,i) in videos" v-bind:key="i" @click="" style="width:100%;">
                                <v-list-item-action>
                                    {{v.ct}}
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Link to video
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-avatar>
                                    <img v-bind:src="thumburl+v.thumb"/>
                                </v-list-item-avatar>
                            </v-list-item>
                        </div>
                    </v-container>


                </v-card-text>
                <v-card-actions>
                    <v-btn text  @click="closemetricsdialog('false')">
                        <v-icon>{{icons.close}}</v-icon> Close
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>




        <!--emaildetailsdialog-->
        <v-dialog
                v-model="emaildetailsdialog"
                :overlay=false
                scrollable
        >
            <v-card v-if="activeemail" >
                <v-toolbar style="flex: 0 0 auto;" dark  >
                    <v-btn icon @click.native="emaildetailsdialog = false" dark>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Email Events</v-toolbar-title>
                </v-toolbar>
                <v-card-title>
                    <span class="etl">To: </span> {{activeemail.destination.name}}
                    <v-spacer></v-spacer>
                    <span class="etl">Organization:</span>{{activeemail.destination.organization}}
                </v-card-title>
                <v-card-text>
                    <span class="etl">Body: </span>
                    <p>{{activeemail.body}}</p>
                    <span class="etl">Email Events: </span>

                    <div v-for="(ae,i) in activeemail.events" class="emailevents">
                        {{ae.eventType}}:
                        <small>
                            <br v-if="ae.eventType=='Click'" >
                            {{ (ae.eventType=="Click") ? "Link: "+  ae.event.link : "" }}<br/>
                            Time: {{ ae.event.timestamp }}
                        </small>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn icon text dark color="awesome" @click.native="emaildetailsdialog = false" >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>





        <v-dialog
                v-model="knowndialog"
                scrollable
        >
            <v-card>
                <v-card-text>
                    <h3>Name: {{knowninfo.toname}}</h3>
                    <div>Email: {{knowninfo.toemail||'none'}}</div>
                    <div>Organization: {{knowninfo.toorg||'none'}}</div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="knowndialog=false;"><v-icon>close</v-icon>Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </div>
</template>

<script>
    import p from '@/views/a4l/Playerschema'
    import {
      mapState,
      mapActions,
      mapMutations
    } from 'vuex'

    export default {
      name: 'Metrics',
      props:['metricsdialog'],
      data() {
        return {
          email: '',
          emailcnt: 0,
          videos: '',
          videoviewsct: 0,
          visitorsct: 0,
          emaildialog: false,
          emaildetailsdialog: false,
          activeemail: false,
          videodialog: false,
          thumburl: this.$store.state.thumburl,
          datadiv: false,
          viewsbyweek: {},
          year: 0,
          week: 0,
          knowndialog: false,
          knowninfo: {}
        }
      },
      computed: {
        ...mapState(['org', 'icons', 'activeplayer', 'athleteobject', 'sportcode']),
        player() {
          return this.activeplayer
        }
      },
      watched: {},
      mounted() {
        this.getWeekNumber(new Date())
        if(!this.player){
          this.selectPlayer(this.$route.params.playerkey)
        }
      },
      components: {},
      methods: {
        ...mapActions(['get', 'post', 'put','selectPlayer','updateMyAthletes']),
        async loadEmails() {
          let data = {
            playerurl: this.player.partkey,
            sender: this.player.info.email
          }
          let res = await this.post({path:'api/share/emails',body:data})
          if (res.Items){
            this.email = res.Items.reverse();
            this.emailcnt = res.Count;
          }
        },
        getemaildetails(sender, messageid) {
          var em = this;
          let args = {
            url: this.$store.state.url + 'api/share/emaildetails',
            method: 'POST',
            data: {
              playerurl: sender,
              messageid: messageid
            }
          }
          this.$store.dispatch('fetch', args)
            .then(function (data) {
              em.emaildetailsdialog = true;
              em.activeemail = data.Item;
            });
        },
        async videoviews() {
          let res = await this.post({path:'api/mobile/videoviews',body: {playerurl: this.player.partkey}})
          this.videoviewsct = res[0].ct;
          this.videos = res;
        },
        async pageviews() {
          let res = await this.get({path:'api/playerv2/pageviews/' + this.player.partkey})
          console.log("Visitor: ", res[0])
          this.visitorsct = res[0].ct;
        },
        async recentPageViews(){
          let res = await this.get({path:'api/playerv2/recentpageviews/' + this.player.partkey })
          console.log(res)
          this.viewsbyweek = res;
          this.datadiv = 'pageviews';
        },
        async pageviewsbyweek(c) {
          let wk;
          console.log(c)
          if (c == 'now') {
            this.getWeekNumber(new Date())
            wk = this.year + ' ' + this.week
          } else if (c == '-') {
            this.week--
            wk = this.year + ' ' + this.week
          } else if (c == '+') {
            this.week++
            wk = this.year + ' ' + this.week
          }
          let res = await this.get({path:'api/playerv2/pageviewsbyweek/' + this.player.partkey + '/' + wk})
          this.viewsbyweek = res;
          this.datadiv = 'pageviews';
        },
        closemetricsdialog() {
          this.$emit('close',true)
        },
        getWeekNumber(d) {
          // Copy date so don't modify original
          d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
          // Set to nearest Thursday: current date + 4 - current day number
          // Make Sunday's day number 7
          d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
          // Get first day of year
          var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
          // Calculate full weeks to nearest Thursday
          var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
          // Return array of year and week number
          this.year = d.getUTCFullYear();
          this.week = weekNo - 1;
        },
        showknown(d) {
          this.knowninfo = d
          this.knowndialog = true
        }
      }
    }
</script>

<style>
    .tilefeature{
        width: 100%;
        font-size: 2.8em;
        top:45px;
        color:#ffffff;
        position:absolute;
        text-align: center;
    }
    .tiletitle{
        font-size: 1em;
        position: absolute;
        bottom: 4px;
        padding-left:8px;
        width:100%;
        color:#fff;
        text-wrap: normal;
    }
    .emailevents{
        margin-top:5px;
        padding:2px;
        border-bottom: solid thin #aaaaaa;
    }
    .etl{
        font-weight: 500;
    }
</style>